var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1246 10.5134C12.1425 9.26799 12.6428 7.67895 12.522 6.07498C12.4012 4.47101 11.6686 2.97481 10.4757 1.89581C9.2828 0.816811 7.72081 0.237558 6.11281 0.277848C4.5048 0.318139 2.97379 0.974892 1.8364 2.11228C0.699013 3.24967 0.0422599 4.78068 0.00196929 6.38869C-0.0383213 7.99669 0.540932 9.55868 1.61993 10.7516C2.69893 11.9445 4.19513 12.6771 5.7991 12.7979C7.40307 12.9187 8.99211 12.4184 10.2376 11.4005L14.1151 15.2773L15 14.3924L11.1246 10.5134ZM9.40916 8.42921H3.14717V7.1791H3.7733V5.30072H5.02484V7.1791H5.65097V3.42305H6.90322V7.1791H7.52935V4.67745H8.78161V7.1791H9.40774L9.40916 8.42921Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBiWhite);
export default __webpack_public_path__ + "static/media/Dashboard BI-white.43c5cb6a7c1723ad338f1205e4385c6d.svg";
export { ForwardRef as ReactComponent };